// import React from 'react';
import InteractiveAddressMap from './maps';
import { useDarkMode } from '../darkmode/DarkModeContext';

const Step2 = ({
  formData,
  errors,
  selectedLocation,
  handlePrevious,
  saveAddressAndProceed,
  isSaving,
  checkCoverage,
  isChecking,
  onAddressSelect
}) => {
  const { isDarkMode } = useDarkMode();

  // Fungsi untuk handle simpan alamat
const handleSaveAddress = () => {
  if (!formData.fullAddress) {
    // console.log("DEBUG formData:", formData); // biar kelihatan isi field
    alert('Silakan pilih lokasi pada peta terlebih dahulu!');
    return;
  }
  saveAddressAndProceed();
};


const handleCheckCoverage = () => {
  if (!formData.fullAddress || !formData.fullAddress.trim()) {
    alert('Silakan pilih lokasi pada peta terlebih dahulu!');
    return;
  }
  checkCoverage();
};

  return (
    <div
      className={`space-y-8 rounded-2xl p-6 transition-all duration-500 ${
        isDarkMode
          ? "bg-gray-800 text-white"
          : "bg-white text-gray-900 shadow-md"
      }`}
    >
      {/* Step Title and Description */}
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold mb-4">Pilih Lokasi Anda</h3>
        <p className={isDarkMode ? "text-gray-300" : "text-gray-600"}>
          Gunakan peta interaktif untuk menentukan lokasi yang tepat
        </p>
      </div>

      {/* Interactive Address Map */}
      <InteractiveAddressMap onAddressSelect={onAddressSelect} />

      {/* Error handling */}
      {errors.fullAddress && (
        <div className="bg-red-500/20 border border-red-500/50 rounded-lg p-4">
          <p className="text-red-400 text-sm">{errors.fullAddress}</p>
        </div>
      )}

      {/* Selected Location Display */}
      {selectedLocation && (
        <div className="bg-green-500/20 border border-green-500/50 rounded-lg p-4">
          <h4 className="font-semibold text-green-600 dark:text-green-300 mb-2">
            ✓ Lokasi Terpilih
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-gray-500 dark:text-gray-400">Kota:</span>
              <span className="ml-2">{selectedLocation.city}</span>
            </div>
            <div>
              <span className="text-gray-500 dark:text-gray-400">Provinsi:</span>
              <span className="ml-2">{selectedLocation.province}</span>
            </div>
            <div>
              <span className="text-gray-500 dark:text-gray-400">Kecamatan:</span>
              <span className="ml-2">{selectedLocation.district}</span>
            </div>
            <div>
              <span className="text-gray-500 dark:text-gray-400">Kelurahan:</span>
              <span className="ml-2">{selectedLocation.village}</span>
            </div>
            <div className="col-span-2">
              <span className="text-gray-500 dark:text-gray-400">Alamat Lengkap:</span>
              <p className="mt-1">{selectedLocation.fullAddress}</p>
            </div>
          </div>
        </div>
      )}

      {/* Navigation and Buttons */}
      <div className="flex flex-col sm:flex-row justify-between pt-6 gap-4">
        {/* Tombol Kembali */}
        <button
          onClick={handlePrevious}
          className="w-full sm:w-auto px-8 py-3 bg-gray-300 dark:bg-gray-700 
                     text-gray-800 dark:text-white font-semibold rounded-xl 
                     hover:bg-gray-400 dark:hover:bg-gray-600 transition-all duration-300"
        >
          Kembali
        </button>

        {/* Group tombol kanan */}
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          {/* Save Address Button */}
          <button
            onClick={handleSaveAddress}
            disabled={isSaving || isChecking || !selectedLocation}
            className="w-full sm:w-auto px-6 py-3 bg-[#1E9B4C] text-white 
                       font-semibold rounded-xl hover:bg-green-700 transition-all duration-300
                       disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSaving ? (
              <div className="flex items-center justify-center space-x-2">
                <div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full"></div>
                <span>Menyimpan...</span>
              </div>
            ) : (
              'Simpan Alamat'
            )}
          </button>

          {/* Check Coverage Button */}
          <button
            onClick={handleCheckCoverage}
            disabled={isChecking || isSaving || !selectedLocation}
            className="w-full sm:w-auto px-8 py-3 bg-gradient-to-r from-[#1E9B4C] to-green-700 
                       text-white font-semibold rounded-xl hover:from-green-700 
                       hover:to-green-800 transition-all duration-300
                       disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isChecking ? (
              <div className="flex items-center justify-center space-x-2">
                <div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full"></div>
                <span>Mengecek...</span>
              </div>
            ) : (
              'Cek Coverage'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step2;